import ResetPassword from "components/ResetPassword/ResetPassword";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { useTranslation, Trans } from "react-i18next";

export default function ForgotPasswordContainer() {
  const { t } = useTranslation();
  useBreadcrumb([
    { name: "Home", url: "/" },
    { name: "Forgot Password", url: "#" },
  ]);
  return (
    <>
      <div className="container mb-8">
        <h1>{t("ResetPassword-title")}</h1>
        <p>{t("ResetPassword-subTitle")}</p>
        <hr />
      </div>
      <ResetPassword />
    </>
  );
}
